import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TVatCorrectionsApi } from './types';

export const vatCorrections: TVatCorrectionsApi = {
	getVatCorrections: (payload) =>
		http
			.post(endpoint.vatCorrections.GET_VAT_CORRECTIONS, payload)
			.then((response) => response.data),
	getSystemTime: () =>
		http.get(endpoint.vatCorrections.GET_SYSTEM_TIME).then((response) => response.data),
	getCurrencies: () =>
		http.get(endpoint.vatCorrections.GET_CURRENCIES).then((response) => response.data),
	getEUCountries: () =>
		http.get(endpoint.country.LOAD_EU_COUNTRIES).then((response) => response.data),
	getExchangeRate: (payload) =>
		http.get(endpoint.vatCorrections.GET_EXCHANGE_RATE(payload)).then((response) => response.data),
	getGbpExchangeRate: (payload) =>
		http
			.get(endpoint.vatCorrections.GET_TO_GBP_EXCHANGE_RATE(payload))
			.then((response) => response.data),
	vatCorrectionSubmit: (payload) =>
		http.post(endpoint.vatCorrections.VAT_CORRECTIONS_REQUEST, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}),
	vatCorrectionDownload: (payload) =>
		http
			.post(endpoint.vatCorrections.VAT_CORRECTIONS_DOWNLOAD, payload, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getOrderAvailableCorrectionAmount: (payload) =>
		http
			.post(endpoint.vatCorrections.GET_ORDER_AVAILABLE_CORRECTION_AMOUNT, payload)
			.then((response) => response.data),
};
